(function () {
  'use strict';

  var cardSelector = '.wishlist-hero-list-card';
  var linkSelector = '.wishlist-hero-list-card-header-product-name[href*="/products/"]';
  var dateSelector = '.wishlist-hero-list-card-header-added-on';
  var viewName = 'jdc-wishlist-release';
  var releaseDateCache = new Map();
  var scanScheduled = false;

  function getReleaseLabel() {
    return (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0
      ? 'Sortie'
      : 'Release';
  }

  function getProductPath(link) {
    try {
      return new URL(link.href, window.location.origin).pathname;
    } catch (error) {
      return '';
    }
  }

  function fetchReleaseDate(productPath) {
    if (releaseDateCache.has(productPath)) {
      return releaseDateCache.get(productPath);
    }

    var separator = productPath.indexOf('?') === -1 ? '?' : '&';
    var request = fetch(productPath + separator + 'view=' + viewName, {
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Release date request failed');
        return response.json();
      })
      .then(function (data) {
        return typeof data.releaseDate === 'string' ? data.releaseDate.trim() : '';
      });

    releaseDateCache.set(productPath, request);
    return request;
  }

  function updateCard(card) {
    var link = card.querySelector(linkSelector);
    var date = card.querySelector(dateSelector);
    if (!link || !date) return;

    var productPath = getProductPath(link);
    if (!productPath) return;

    fetchReleaseDate(productPath)
      .then(function (releaseDate) {
        if (!date.isConnected) return;

        if (!releaseDate) {
          date.hidden = true;
          return;
        }

        var label = getReleaseLabel();
        var displayValue = label + ' : ' + releaseDate;
        date.hidden = false;
        date.title = label;
        date.setAttribute('aria-label', displayValue);
        if (date.textContent !== displayValue) date.textContent = displayValue;
      })
      .catch(function () {
        // En cas d'indisponibilité du point de lecture, Wishlist Hero conserve sa date native.
      });
  }

  function scanWishlist() {
    scanScheduled = false;
    document.querySelectorAll(cardSelector).forEach(updateCard);
  }

  function scheduleScan() {
    if (scanScheduled) return;
    scanScheduled = true;
    window.requestAnimationFrame(scanWishlist);
  }

  var observer = new MutationObserver(scheduleScan);

  function init() {
    observer.observe(document.body, { childList: true, subtree: true });
    scheduleScan();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
